import { Coins } from "lucide-react";

interface CurrencyFormatHintProps {
  currency?: "ARS" | "USD";
}

export default function CurrencyFormatHint({
  currency = "ARS",
}: CurrencyFormatHintProps) {
  // Siempre usamos formato argentino (coma decimal, punto miles)
  // porque los usuarios son argentinos, independiente de la moneda
  if (currency === "USD") {
    return (
      <div className="flex items-center gap-2 text-xs text-gray-500">
        <Coins className="h-3.5 w-3.5 flex-shrink-0" />
        <span>
          Formato argentino: punto para miles (1.234) y coma para decimales
          (hasta 4). Evitá el formato US (1,234.56). Podés escribir el entero
          y la coma para los decimales. Ejemplos: 1.234,5600 dólares • 12.000
          dólares • 9,9999 dólares
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs text-gray-500">
      <Coins className="h-3.5 w-3.5 flex-shrink-0" />
      <span>
        Formato argentino: punto para miles (1.234) y coma para decimales
        (,56). Evitá el formato US (1,234.56). Podés escribir el entero y la
        coma para los decimales. Ejemplos: 1.234,56 pesos • 12.000 pesos •
        9,99 pesos
      </span>
    </div>
  );
}
